<template>
    <ValidationProvider
        rules="max:255"
        v-slot="{ errors }"
    >
        <v-text-field
            v-model="text"
            :label="name"
            outlined
            :error-messages="errors"
            @change="emitFieldData"
        />
    </ValidationProvider>
</template>

<script>
import { EventBus } from '@/store/eventBus';
import InputBoilerplate from '@/views/Common/Input/InputBoilerplate';

export default {
    mixins: [ InputBoilerplate ],

    data() {
        return {
            text: '',
        };
    },

    methods: {
        loadFieldData() {
            this.text = this.inputData;
        },

        emitFieldData() {
            EventBus.$emit(`${this.namespace}UpdateFieldData`, {
                text: this.text,
            });
        }
    }
};
</script>
